<template>
<div class="dropdown notification-mm-wrapper">
	<md-menu md-direction="bottom-end">
		<a class="nav-link dropdown-toggle notifications-toggle" :class="{ 'unread': isHasUnread }" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" md-menu-trigger>
			<div class="notifications-icon icon-toggle" :data-unread="unreadDisplay">
				<i class="material-icons">message</i>
				<span class="notification-counter-badge" v-if="totalUnreadMessages > 0 && notificationAlert">{{ totalUnreadMessages }}</span>
			</div>
			<div class="label ml-2">{{ $t('messages') }}</div>
		</a>
		<md-menu-content class="mm-material-notifications">
			<div class="notifications-actions clearfix">
				<div class="float-left title-label">{{ $t('messages') }}</div>
				<div class="float-right"><a href="#" @click="onMarkAllAsRead">{{ $t('markAllAsRead') }}</a></div>
			</div>
			<div class="notifications-list" @scroll="handleScroll">
				<notification v-for="(notification, index) in sortedNotifications" :key="index" :notificationType="notificationType" :item="notification">
				</notification>
				<notification v-if="sortedNotifications.length === 0" :notificationType="notificationType" :item="emptyNotification"></notification>
				<div class="notification-loader is-loading" v-if="isFetching"></div>
			</div>
		</md-menu-content>

		<!-- <div class="notifications-wrapper dropdown-menu dropdown-menu-right">
			<div class="notifications-actions clearfix">
				<div class="float-left title-label">{{ $t('messages') }}</div>
				<div class="float-right"><a href="#" @click="onMarkAllAsRead">{{ $t('markAllAsRead') }}</a></div>
			</div>
			<div class="notifications-list" @scroll="handleScroll">
				<notification v-for="(notification, index) in sortedNotifications" :key="index" :notificationType="notificationType" :item="notification">
				</notification>
				<notification v-if="sortedNotifications.length === 0" :notificationType="notificationType" :item="emptyNotification"></notification>
				<div class="notification-loader is-loading" v-if="isFetching"></div>
			</div>
		</div> -->
	</md-menu>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Notification from '@/components/Notification.vue';
import notificationsApi from '@/api/notifications';

export default {
	name: 'MessageNotifications',
	components: {
		Notification,
	},
	data() {
		return {
			isFetching: false,
			limit: 10,
			sortBy: 'created_at',
			sort: 'desc',
			page: 1,
			emptyNotification: {
				type: 'empty',
				seen: true,
			},
			unread: 0,
			notificationType: 'message',
		};
	},
	methods: {
		...mapActions({
			setMessageNotifications: 'setMessageNotifications',
			setSelectedNotification: 'setSelectedNotification',
		}),
		getNotifications(page = 1, limit = 10) {
			const callback = (response) => {
				const notifications = response.data;
				this.$store.dispatch('setMessageNotifications', notifications);
				this.isFetching = false;
			};
			const errorCallback = (error) => {
				const message = error.response.data.message;
				this.$notify({
					group: 'foo-velocity',
					title: this.$t('error'),
					text: message,
					type: 'error',
				});

				this.isFetching = false;
			};
			const params = {
				page,
				limit,
				is_message: 1,
			};
			notificationsApi.getList(params, callback, errorCallback);

			if (this.filteredNotifications.length === 0) {
				this.isFetching = true;
			}
		},
		handleScroll(event) {
			const elem = event.target;
			const height = elem.offsetHeight;
			const scrollTop = elem.scrollTop;
			const scrollHeight = elem.scrollHeight;
			if ((scrollTop + height) >= scrollHeight) {
				if (!this.isFetching) {
					this.getNotifications();
				}
			}
		},
		onMarkAllAsRead(event) {
			event.preventDefault();
			this.markAllAsRead();
		},
		markAllAsRead() {
			const params = {
				is_message: 1,
			};
			const callback = () => {
			};
			const errorCallback = () => {
			};
			notificationsApi.markAllAsRead(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			messageNotifications: 'messageNotifications',
		}),
		isHasUnread() {
			return this.unread > 0;
		},
		unreadDisplay() {
			return this.unread <= 99 ? this.unread : '99+';
		},
		filteredNotifications() {
			const filtered = this.messageNotifications.filter(curr => curr.type === 'message');
			return filtered;
		},
		sortedNotifications() {
			const listSize = 7;
			const notifications = this.filteredNotifications.slice(0, listSize);
			return notifications;
		},
		unreadMessages() {
			const filter = (message) => {
				const isUnread = message.status === 'unread';
				const isFilter = isUnread;
				return isFilter;
			};
			const unreads = this.filteredNotifications.filter(filter);
			return unreads;
		},
		totalUnreadMessages() {
			const unread = this.unreadMessages.length <= 99 ? this.unreadMessages.length : '99+';
			return unread;
		},
		notificationAlert() {
			let isShow = false;
			if (this.user) {
				isShow = this.user.is_notification_visible;
			}
			return isShow;
		},
	},
	created() {
		this.getNotifications();
	},
};
</script>

<style lang="scss" scoped>
</style>
